module.exports = __webpack_public_path__ + "img/deepwater-green-outer-corner.3554bc7b.png";